import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Header from "../Header";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import { Circles } from "react-loader-spinner";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";

const FeedbackForm = () => {
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!feedback.trim()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Feedback cannot be empty!",
      });
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Thank You!",
        text: "Your feedback has been submitted successfully.",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        history.push("/apps");
      });
    }, 1500);
  };

  return (
    <>
      <div className="container-scroller">
        <Header />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-12 grid-margin">
                  <div className="card shadow-lg p-4">
                    <div className="card-body">
                      <form className="form-sample mt-4" onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="form-label fs-5 fw-bold">
                            Your Feedback:
                          </label>
                          <div className="editor-container border p-2 rounded">
                            <CKEditor
                              editor={ClassicEditor}
                              data={feedback}
                              onChange={(event, editor) => {
                                setFeedback(editor.getData());
                              }}
                              config={{
                                height: 300,
                              }}
                            />
                          </div>
                        </div>
                        <div className="text-center mt-4">
                          <button type="submit" className="Button col-sm-2 col-form-label text-center mr-2">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      {loading && (
        <div className="fullscreen-loader">
          <Circles color="#F1B621" height={80} width={80} />
        </div>
      )}
    </>
  );
};

export default FeedbackForm;
